import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import equalHeight from '../functions/equalHeight';
import {getProducts} from '../actions/productActions';
import {getSurface} from '../actions/surfaceActions';
import Truncate from 'react-truncate-html';
import PropTypes from 'prop-types';
import api from '../api';
import {APP_TITLE} from '../constants/config';
import { Helmet } from 'react-helmet';

class Choices extends React.Component{
    constructor(props){
        super(props);
        this.state = {email: ''};

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        equalHeight(document.querySelectorAll('.item .image'));
        equalHeight(document.querySelectorAll('.item .bg-white'), 20);
    }

    handleEmailChange(e) {
        this.setState({email: e.target.value});
    }

    handleSubmit(e) {
        e.preventDefault();
        let choices = [];

        for (const product of this.props.choices) {
            choices.push(product.id);
        }

        api.sendChoicesEmail({
            email: this.state.email,
            choices: choices,
        }, () => {
            alert("Email sent successfully");
        });
    }

    heading() {
        if(this.props.surface.name) {
            return (
                <h2 className="entry-title"><small>Your {this.props.surface.name} surface</small><br />Here are your choices</h2>
            );
        }

        return (
            <h2 className="entry-title">Here are your choices</h2>
        );
    }

    render(){
        if(this.props.choices.length > 0) {
            return (
                <div id="choices">
                    {this.heading()}
                    <Helmet>
                        <title>Your Choices | {APP_TITLE}</title>
                    </Helmet>
                    <div className="row entry">
                        {this.props.choices.map((b, i) =>
                            <div key={i} className="col-12 col-md-6 col-lg-4 col-xl-3 mb-5">
                                <Link to={"/product/" + b.slug} className="item product-small">
                                    <div className="image d-flex align-items-end">
                                        <img src={b.image} className="img-fluid" alt={b.name}/>
                                    </div>
                                    <div className="bg-white p-4">
                                        <span className="category d-inline-block bg-primary text-white">{b.category.name}</span>
                                        <h3 className="mt-3">{b.title}</h3>
                                        <div className="entry-content">
                                            <Truncate lines={3} dangerouslySetInnerHTML={{__html: b.content_filtered}}/>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )}
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-8">
                            <form className="d-flex align-items-center px-3" onSubmit={this.handleSubmit}>
                                <label className="text-uppercase m-0">Email your choices</label>
                                <input name="email-address" type="email" className="form-control mx-4" placeholder="Enter your email address here" value={this.state.email} onChange={this.handleEmailChange}/>
                                <button type="submit" className="btn btn-primary">Send</button>
                            </form>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div id="choices">
                    <h2 className="entry-title">You haven't selected any products</h2>
                    <div className="text-center">
                        <Link to="/" className="btn btn-primary">Back to start</Link>
                    </div>
                </div>
            );
        }
    }


}

// Maps state from store to props
const mapStateToProps = (state, props) => {
    return {
        // You can now say this.props.books
        surface: getSurface(props.params.floorSurface, state),
        choices: getProducts(state.choices, state.products)
    };
};

Choices.propTypes = {
    surface: PropTypes.object,
    choices: PropTypes.array,
};

// Use connect to put them together
export default connect(mapStateToProps)(Choices);



// WEBPACK FOOTER //
// ./src/components/Choices.js